module.exports = __webpack_public_path__ + "img/zhuanpan.86f13eaa.png";